import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { IHashMap } from "shared/interface/types";

export interface IGlobalState {
  NumericTypeValuesHashMap: IHashMap;
  AgeDurationTypeValuesHashMap: IHashMap;
  RateModeTypeHashMapFromName: IHashMap;
  AgeDurationTypeValuesHashMapFromName: IHashMap;
  NumericTypeValuesHashMapFromName: IHashMap;
  SalePointHashMap: IHashMap;
}

const initialState: IGlobalState = {
  NumericTypeValuesHashMap: {},
  AgeDurationTypeValuesHashMap: {},
  AgeDurationTypeValuesHashMapFromName: {},
  RateModeTypeHashMapFromName: {},
  NumericTypeValuesHashMapFromName: {},
  SalePointHashMap: {}
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    UpdateTypeValueHashMap: (state, { payload: { name, data } }: { payload: { name: keyof typeof initialState; data: IHashMap } }) => {
      state[name] = data;
    }
  }
});

export const { UpdateTypeValueHashMap } = globalSlice.actions;
export default globalSlice.reducer;

export const getGlobalState = (state: RootState): IGlobalState => state.global;
